export default {"src":"/_next/static/media/badge-certificate.69d7de51.svg","height":72,"width":72,"blurWidth":0,"blurHeight":0};